import './style.css'
import Maqueta from './Maqueta/Maqueta.js'

const maqueta = new Maqueta(document.querySelector('canvas.webgl'))